module.exports = __webpack_public_path__ + "static/media/mall-discount.37032d28.svg";